import * as React from 'react';
import classnames from 'classnames';

import './box.scss';

type Props = {
  children: React.ReactNode,
  bordered?: boolean,
  boxed?: boolean,
  padding?: 'horizontal' | 'normal'
};

class Box extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { children, bordered, boxed, padding } = this.props;

    const boxClasses = classnames({
      'box': boxed,
      'box--bordered': bordered,
      [`box--padding-${String(padding)}`]: padding
    });

    return (
      <section className={boxClasses}>
        {children}
      </section>
    );
  }
}

export default Box;
